<style>
.el-dialog__bod {
  padding-top: 10px;
}
</style>
<template>
  <div>
    <el-dialog
      title="微信扫码登录"
      :visible="this.$store.state.loginFormVisible"
      @close="cancel"
      width="480px"
    >
      <iframe :src="src" style="width:100%;height:450px;border:0;"></iframe>
    </el-dialog>
  </div>
</template>

<script>
export default {
  methods: {
    cancel () {
      this.$store.commit('loginFormVisible', false)
    },
    init () {}
  },
  mounted () {
    this.init()
  },
  data () {
    return {
      src: '/static/login/weixin.html?__t=' + new Date().getTime() + ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/login.vue